import { format } from "date-fns";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

interface Transaction {
  created_at: string;
  amount: number;
  commission_amount: number;
  status: string;
  currency: string;
}

interface TransactionsTableProps {
  transactions: Transaction[];
}

export const TransactionsTable = ({ transactions }: TransactionsTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Date</TableHead>
          <TableHead>Amount</TableHead>
          <TableHead>Commission</TableHead>
          <TableHead>Status</TableHead>
          <TableHead>Currency</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {transactions?.map((transaction, index) => (
          <TableRow key={index}>
            <TableCell>
              {format(new Date(transaction.created_at), 'MMM dd, yyyy')}
            </TableCell>
            <TableCell>${Number(transaction.amount).toFixed(2)}</TableCell>
            <TableCell>${Number(transaction.commission_amount).toFixed(2)}</TableCell>
            <TableCell>
              <span className={`px-2 py-1 rounded-full text-xs ${
                transaction.status === 'completed' 
                  ? 'bg-green-100 text-green-800' 
                  : 'bg-yellow-100 text-yellow-800'
              }`}>
                {transaction.status}
              </span>
            </TableCell>
            <TableCell>{transaction.currency}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};